import React, {
  useState,
  useContext,
  useRef,
  useLayoutEffect,
} from "react";
import { Tab, Tabs } from "react-bootstrap";

import Grid from "./Grid";
import SlidersTop from "./SlidersTop";
import EmptyState from "./EmptyState";
import { ProfileContext } from "../../../context/ContextProfile";

import { IonIcon } from "@ionic/react";
import {
  diamond,
  diamondOutline,
  images,
  imagesOutline,
  bed,
  bedOutline,
  briefcase,
  briefcaseOutline,
  cubeOutline,
  cube,
} from "ionicons/icons";

const TAB_KEYS = ["Top", "mainGallery", "experiencias", "casas", "Empleo"];

function GridGallery() {
  const { village } = useContext(ProfileContext);
  const [key, setKey] = useState("Top");
  const wrapRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);

  // Keep the sliding indicator aligned with the bottom of the tab bar,
  // even if its height changes (font size, wrapping…).
  useLayoutEffect(() => {
    const nav = wrapRef.current?.querySelector(".nav-tabs");
    if (!nav) return;
    const measure = () => setNavHeight(nav.offsetHeight);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(nav);
    return () => ro.disconnect();
  }, []);

  const activeIndex = Math.max(0, TAB_KEYS.indexOf(key));

  return (
    <>
      {village.villagePictures && (
        <>
          {village.villagePictures.mainGallery.length === 0 ? (
            <EmptyState icon="fa-camera" title="Sin fotos todavía">
              Este perfil aún no tiene publicaciones.
            </EmptyState>
          ) : (
            <div className="tabs-wrap" ref={wrapRef}>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3 custom-tab-list "
                style={{
                  marginBottom: "0px !important",
                }}
              >
                <Tab
                  eventKey="Top"
                  title={
                    <>
                      <IonIcon
                        icon={key === "Top" ? diamond : diamondOutline}
                        className={
                          key === "Top" ? "active-tab" : "inactive-icon"
                        }
                      />
                      <p
                        className={
                          key === "Top" ? "active-tab" : "inactive-icon"
                        }
                      >
                        Top
                      </p>
                    </>
                  }
                >
                  {/* Your custom Grid component for Main Gallery */}
                  <SlidersTop
                    mostVisited={village.villageMostVisited}
                    recommendations={village.villageRandomPosts}
                    displayName={village.villageData.displayName}
                    code={village.code}
                    profilePicture={village.villageData.profilePicture}
                    village={village}
                  />
                </Tab>
                <Tab
                  eventKey="mainGallery"
                  title={
                    <>
                      <IonIcon
                        icon={key === "mainGallery" ? images : imagesOutline}
                        className={
                          key === "mainGallery" ? "active-tab" : "inactive-icon"
                        }
                      />
                      <p
                        className={
                          key === "mainGallery" ? "active-tab" : "inactive-icon"
                        }
                      >
                        Perfil
                      </p>
                    </>
                  }
                >
                  {/* Your custom Grid component for Main Gallery */}
                  <Grid
                    images={village.villagePictures.mainGallery}
                    displayName={village.villageData.displayName}
                    code={village.code}
                    profilePicture={village.villageData.profilePicture}
                    village={village}
                  />
                </Tab>
                <Tab
                  eventKey="experiencias"
                  title={
                    <>
                      <IonIcon
                        icon={key === "experiencias" ? cube : cubeOutline}
                        className={
                          key === "experiencias"
                            ? "active-tab"
                            : "inactive-icon"
                        }
                      />
                      <p
                        className={
                          key === "experiencias"
                            ? "active-tab"
                            : "inactive-icon"
                        }
                      >
                        Bar Box
                      </p>
                    </>
                  }
                >
                  {/* Your custom Grid component for Main Gallery */}
                  <Grid
                    images={village.villagePictures.mainGallery}
                    displayName={village.villageData.displayName}
                    code={village.code}
                    profilePicture={village.villageData.profilePicture}
                    village={village}
                    isExperience={true}
                  />
                </Tab>
                <Tab
                  eventKey="casas"
                  title={
                    <>
                      <IonIcon
                        icon={key === "casas" ? bed : bedOutline}
                        className={
                          key === "casas" ? "active-tab" : "inactive-icon"
                        }
                      />
                      <p
                        className={
                          key === "casas" ? "active-tab" : "inactive-icon"
                        }
                      >
                        Casas
                      </p>
                    </>
                  }
                >
                  {/* Your custom Grid component for Main Gallery */}
                  <Grid
                    images={village.villagePictures.mainGallery}
                    displayName={village.villageData.displayName}
                    code={village.code}
                    profilePicture={village.villageData.profilePicture}
                    village={village}
                    isHousing={true}
                  />
                </Tab>
                <Tab
                  eventKey="Empleo"
                  title={
                    <>
                      <IonIcon
                        icon={key === "Empleo" ? briefcase : briefcaseOutline}
                        className={
                          key === "Empleo" ? "active-tab" : "inactive-icon"
                        }
                      />
                      <p
                        className={
                          key === "Empleo" ? "active-tab" : "inactive-icon"
                        }
                      >
                        Empleo
                      </p>
                    </>
                  }
                >
                  <Grid
                    images={village.villagePictures.mainGallery}
                    displayName={village.villageData.displayName}
                    code={village.code}
                    profilePicture={village.villageData.profilePicture}
                    village={village}
                    isJob={true}
                  />
                </Tab>
              </Tabs>

              <span
                className="tab-indicator"
                style={{
                  top: navHeight ? navHeight - 3 : undefined,
                  width: `${100 / TAB_KEYS.length}%`,
                  transform: `translateX(${activeIndex * 100}%)`,
                }}
              />

              <div className="top-line"></div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default GridGallery;
